import { AccountServant } from '../servants/account_servant';
import { IBuilder } from 'core-ts-types';

export interface IAccountAPI extends IBuilder {
  token: string;
}
export interface IAccount extends IAccountAPI {
  readonly isAnonymous: boolean;
  expire_time: number;
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  view_all_codes_preference: boolean;
}

export class Account implements IAccount {
  ttl_in_seconds = 30 * 60;
  ttl_lead_time_in_seconds = 6 * 60;

  isAnonymous: boolean = true;
  id: string = 'account';
  tracking_id: string = '';
  token: string = '';
  expire_time: number;
  first_name: string = '';
  last_name: string = '';
  email: string = '';
  is_transfer_admin: boolean = false;
  is_application_admin: boolean = false;
  is_transfer_counselor: boolean = false;
  is_transfer_analytics_user: boolean = false;
  is_transfer_delivery: boolean = false;
  is_confirmed: boolean = false;
  view_all_codes_preference: boolean = false;

  constructor(account: Partial<IAccount>) {
    _.merge(this, account);
    this.token = this.token || this['lazy-token'];
    Account.updateExpireTime(this);
  }

  static build(account: Partial<IAccount>): Account {
    return new Account(account);
  }

  static updateExpireTime(account: Account): void {
    account.expire_time = Date.now() + (account.ttl_in_seconds - account.ttl_lead_time_in_seconds - 60) * 1000;
  }
}

angular.module('capability-ng-user-app').factory('ngAccountBuilder', function(): typeof Account {
  return Account;
});



// WEBPACK FOOTER //
// ./app/lib/user_app/builders/account_builder.ts